import fetch from 'cross-fetch'; // eslint-disable-line no-unused-vars
import { RSAA } from 'redux-api-middleware';
import { saveAs } from 'file-saver';
import Routes from 'utils/routes.js.erb';
import { addMeta } from './transformers';
import { API_FAILURE, AUTH_TOKEN, authHeaders } from './index';

export const ASQ_REPORT_REQUEST = 'ASQ_REPORT_REQUEST';
export const ASQ_REPORT_RECEIVE = 'ASQ_REPORT_RECEIVE';

const downloadFile = (res, defaultFileName) => {
  const contentDisposition = res.headers.get('content-disposition');
  let fileName = defaultFileName;
  if (contentDisposition) {
    const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
    if (fileNameMatch.length === 2) {
      fileName = fileNameMatch[1];
    }
  }
  saveAs(res._bodyBlob, fileName);
  return null;
}

const fetchASQReport = (params, meta = {}) => {
  let headers = authHeaders();
  headers['Accept'] = 'application/pdf';
  headers['Content-Type'] = 'application/pdf';
  return {
    [RSAA]: {
      endpoint: Routes.api_dashboard_asq_survey_path(params, { format: 'pdf', locale: meta.locale }),
      headers: headers,
      method: 'GET',
      types: [
        addMeta(ASQ_REPORT_REQUEST, meta),
        {
          type: ASQ_REPORT_RECEIVE,
          payload: (action, state, res) => downloadFile(res, 'ASQ Report.pdf'),
        },
        API_FAILURE,
      ],
      fetch: fetch,
    },
  }
}

export const downloadASQReport = (params, meta = {}) => {
  return fetchASQReport(params, meta);
}

export const downloadPDF = async (url, filename = 'download.pdf', beforeStart = () => { }, afterFinish = () => { }) => {
  const headers = {
    'Authorization': window.auth_session_token || localStorage.getItem(AUTH_TOKEN),
    'JWTAUD': 'dashboard',
  }

  try {
    beforeStart();

    const response = await fetch(url, {
      method: 'GET',
      headers: headers,
    });

    if (response.status === 200) {
      const blob = await response.blob();
      const contentDisposition = response.headers.get('content-disposition');
      let finalFilename = filename;
      if (contentDisposition && contentDisposition.indexOf('inline') === -1) {
        const match = contentDisposition.match(/filename="(.+)"/);
        if (match && match[1]) {
          finalFilename = match[1];
        }
      }
      saveAs(blob, finalFilename);
    }
  } finally {
    afterFinish();
  }
}
